export const EmailTemplateTypes = {
    API_RESPONSE_ERROR: '@@user/API_RESPONSE_ERROR',
    API_RESPONSE_SUCCESS: '@@user/API_RESPONSE_SUCCESS',
    CREATE_EDITCUSTOMEMAILTEMPLATE: '@@user/CREATE_EDITCUSTOMEMAILTEMPLATE',
    RESET: '@@user/RESET',
};
